import type { ReactElement } from "react";

import { useDispatch } from "react-redux";

import { isSignalsManagementOpenAction } from "app/pages/sales-intelligence/sub-modules/signals/store/action-creators";

import { StyledSignalsManagementButton } from "./styles";

export const SignalsCategoryHeaderAction = (): ReactElement => {
    const dispatch = useDispatch();

    return <StyledSignalsManagementButton onClick={() => dispatch(isSignalsManagementOpenAction(true))} />;
};
